// Campaign message configuration for social media ad campaigns

export interface CampaignConfig {
  id: string;
  message: string;
  // Future: could add metadata like category, language, A/B variants
}

export const CAMPAIGN_MESSAGES: Record<string, CampaignConfig> = {
  ms_study: {
    id: 'ms_study',
    message: 'Ich habe MS und möchte mehr über die Teilnahme an klinischen Studien erfahren.',
  },
  // Easy to add more campaigns later:
  // parkinson_study: { id: 'parkinson_study', message: '...' },
};

export function getCampaignMessage(campaignId: string): string | null {
  return CAMPAIGN_MESSAGES[campaignId]?.message ?? null;
}
